import { useEffect, useRef } from 'react';
export var useInfiniteScroll = _ref => {
  var {
    onScrollPage
  } = _ref;
  var scrollDivRef = useRef(null);
  /**
   * Handle infinite scrolling
   */
  useEffect(() => {
    var divRef = scrollDivRef.current;
    var options = {
      root: null,
      rootMargin: '0px',
      threshold: 1
    };
    var observer = new IntersectionObserver(_ref2 => {
      var _entry$rootBounds;
      var [entry] = _ref2;
      var isScrollingDown = entry.boundingClientRect.y > (((_entry$rootBounds = entry.rootBounds) === null || _entry$rootBounds === void 0 ? void 0 : _entry$rootBounds.y) || 0);
      if (entry.isIntersecting && isScrollingDown) {
        onScrollPage();
      }
    }, options);
    if (divRef) observer.observe(divRef);
    return () => {
      if (divRef) observer.unobserve(divRef);
    };
  }, [onScrollPage]);
  return {
    scrollDivRef
  };
};